import * as React from 'react'
import { cn } from '@/lib/utils'

function Card({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'bg-card text-card-foreground flex flex-col rounded-xl border shadow-sm',
        className,
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('flex flex-col gap-1.5 px-6 pt-6', className)} {...props} />
}

function CardTitle({ className, ref, ...props }: React.ComponentProps<'h1'>) {
  return (
    <h1
      ref={ref}
      tabIndex={-1}
      className={cn('text-xl font-semibold tracking-tight outline-none', className)}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }: React.ComponentProps<'p'>) {
  return <p className={cn('text-muted-foreground text-sm', className)} {...props} />
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('px-6 py-6', className)} {...props} />
}

export { Card, CardHeader, CardTitle, CardDescription, CardContent }
